import { mergeStyleSets } from "@fluentui/react";

export const useStyles = () => {
  return mergeStyleSets({
    fieldDescription: {
      fontSize: '12px',
      marginTop: '4px',
      fontWeight: 300,
    },
    pullModeCheckbox: {
      marginTop: '12px',
    },
    groupPane: {
      '& > div:first-child': {
        paddingLeft: '0',
        paddingRight: '0',
      },
    },
    filterManagerButton: {
      fontWeight: 600,
      width: '100%',
    },
  });
}
